import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Segment } from 'semantic-ui-react';

import Label_T from 'common/typography/Label/Label';
import Button from 'common/components/atoms/Button';
import FlexContainer from 'common/components/atoms/FlexContainer';
import {
  ResourceItemLabel,
  ResourceInputField,
  ResourceItem,
} from 'common/components/atoms/ResourceDetails';

const TextLabel = styled(Label_T)`
  margin-top: 4px;
`;

const ConfirmActions = styled(FlexContainer)`
  margin-top: 10px;
  gap: 10px;
`;

const CancelButton = styled(Button)`
  margin-right: 0;
`;

function SiteReassignField({
  t,
  editMode,
  siteOptions,
  selectValue,
  siteDisplayName,
  disabled,
  submitting,
  hasPendingReassign,
  onSiteChange,
  onConfirmReassign,
  onCancelPending,
  showDisabledHint,
  disabledHint,
}) {
  return (
    <Segment>
      <ResourceItemLabel>
        {t('sensors.detail.site')}
      </ResourceItemLabel>
      {editMode ? (
        <ResourceInputField
          type="select"
          search
          options={siteOptions}
          value={selectValue}
          disabled={disabled || submitting}
          onChange={(e, { value }) => onSiteChange(value)}
          placeholder={t('sensors.detail.selectSite')}
        />
      ) : (
        <ResourceItem>
          {siteDisplayName}
        </ResourceItem>
      )}
      {editMode && hasPendingReassign && !disabled && (
        <ConfirmActions direction="row" alignItems="center">
          <CancelButton
            secondary="#000"
            onClick={onCancelPending}
            disabled={submitting}
          >
            {t('sensors.reassignSite.cancel')}
          </CancelButton>
          <Button
            onClick={onConfirmReassign}
            disabled={submitting}
          >
            {t('sensors.reassignSite.confirm')}
          </Button>
        </ConfirmActions>
      )}
      {showDisabledHint && (
        <TextLabel fontSize="12px" grey>
          {disabledHint || t('sensors.detail.siteDisabledHint')}
        </TextLabel>
      )}
    </Segment>
  );
}

SiteReassignField.propTypes = {
  t: PropTypes.func.isRequired,
  editMode: PropTypes.bool.isRequired,
  siteOptions: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })).isRequired,
  selectValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  siteDisplayName: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  submitting: PropTypes.bool,
  hasPendingReassign: PropTypes.bool,
  onSiteChange: PropTypes.func.isRequired,
  onConfirmReassign: PropTypes.func.isRequired,
  onCancelPending: PropTypes.func.isRequired,
  showDisabledHint: PropTypes.bool,
  disabledHint: PropTypes.string,
};

SiteReassignField.defaultProps = {
  selectValue: '',
  disabled: false,
  submitting: false,
  hasPendingReassign: false,
  showDisabledHint: false,
  disabledHint: '',
};

export default SiteReassignField;
